export default "__VITE_ASSET__X6atr6X$__"